import app from 'apprun';
declare var $;

app.on('//', route => {
  const menus = document.querySelectorAll('.navbar-nav li');
  for (let i = 0; i < menus.length; ++i) menus[i].classList.remove('active');
  const item = document.querySelector(`[href='${route}']`);
  item && item.parentElement.classList.add('active');
});

app.on('set-page-title', title => (document.getElementById('page-title').innerText = title));

/*
const $toast = $('#toast');
let toastid;

app.on('show-message', (msg, duration = 5000) => {
  if (toastid) {
    clearTimeout(toastid);
    $toast.html(`${$toast.html()} ${msg ? `<br>${msg}` : ''}`);
    toastid = null;
  } else if (msg) {
    $toast.html(msg).slideToggle();
  } else {
    $toast.slideToggle();
  }
  toastid = setTimeout(() => {
    $toast.slideToggle();
    toastid = null;
  }, duration);
});
*/
// app.on('clear-message', () => {
//   $toast.hide();
//   $toast.html('');
//   if (toastid) {
//     clearTimeout(toastid);
//     toastid = null;
//   }
// });

//import './rbc';
import './message-center/message-center';
import './Registration';
import './set-password';
import './loading-indicator';

window['apprun'] = app;

